<template>
<div v-if="(!loaded)"></div>
<div v-if="(loaded)" id="app-content">
  <div class="header w-full top-0 left-0 z-5">
    <div class="flex flex-column lg:flex-row">
      <div class="flex flex-grow-1">
        <MenuPrincipal id="menu" />
      </div>
    </div>
  </div>
  <div class="app-page">
    <div class="absolute z-3 translateAlert hidden sm:block" v-html="fc_getText(null, 'translateAlert')"></div>
    <router-view :key="$route.name" />
  </div>
  <AppFooter />
  <DynamicDialog />
  <ScrollTop />
  <div class="cookies-banner" v-if="(viewCookiesBanner)">
    <div class="cookies-banner-text">
      <span v-html="fc_getText(null, 'bannerCookies')"></span>
      <span @click="fc_goRoute('politicaDePrivacidade')" class="cursorPointer" v-html="(fc_getText(null, 'politicaDePrivacidade') + '.')"></span>
    </div>
    <button @click="mt_consentCookies()" v-html="fc_getText(null, 'bannerCookies_aceitar')"></button>
  </div>
  <Toast>
    <template #message="slotProps">
      <span class="p-icon p-toast-message-icon"><i :class="'pi ' + fc_getIconSeverity(slotProps.message.severity) + ' text-4xl'"></i></span>
      <div class="p-toast-message-text">
        <span class="p-toast-summary" v-html="slotProps.message.summary"></span>
        <div class="p-toast-detail" v-html="slotProps.message.detail" />
      </div>
    </template>
  </Toast>
</div>
</template>

<script>
import { usePrimeVue } from 'primevue/config';
import txt_primevue from '@/common/json/txt_primevue.json';
import MenuPrincipal from '@/components/MenuPrincipal.vue';
import ScrollTop from 'primevue/scrolltop';
import AppFooter from '@/components/AppFooter.vue';

export default {
  components: {
    MenuPrincipal,
    ScrollTop,
    AppFooter
  },
  data() {
    return {
      loaded: false,
      viewCookiesBanner: false,
      menus: {},
    };
  },
  props: {},
  computed: {},
  watch: {},
  methods: {
    mt_start() {
      if (this.mt_getCookie("cookieconsent_status") !== 'dismiss') {
        this.viewCookiesBanner = true;
      } else {
        this.viewCookiesBanner = false;
      }

      this.loaded = true;
    },
    mt_consentCookies() {
      const date = new Date();
      date.setTime(date.getTime() + (365 * 24 * 60 * 60 * 1000));
      const expires = "expires=" + date.toUTCString();
      document.cookie = 'cookieconsent_status=dismiss;' + expires + ";path=/";

      this.viewCookiesBanner = false;
    },
    mt_getCookie(nome) {
      const cookie = document.cookie
        .split(';')
        .map(c => c.trim())
        .find(c => c.startsWith(nome + '='));

      if (cookie) { return decodeURIComponent(cookie.split('=')[1]); } 
      else { return null; }
    }
  },
  created() {
    this.$store.state.lang = this.fc_getLang();

    const primevue = usePrimeVue();
    if (this.$store.state.lang === 'pt') {
      this.$store.state.dictionary_primevue = txt_primevue.pt;
      primevue.config.locale = txt_primevue.pt;
    } else if (this.$store.state.lang === 'en') {
      this.$store.state.dictionary_primevue = txt_primevue.en;
      primevue.config.locale = txt_primevue.en;
    } else if (this.$store.state.lang === 'fr') {
      this.$store.state.dictionary_primevue = txt_primevue.fr;
      primevue.config.locale = txt_primevue.fr;
    } else if (this.$store.state.lang === 'es') {
      this.$store.state.dictionary_primevue = txt_primevue.es;
      primevue.config.locale = txt_primevue.es;
    }

    this.$router.beforeEach((to, from, next) => {
      this.$store.state.prevRoute = from;
      next();
    });
  },
  mounted() {
    new window.WOW().init();
    let promises = [];
    promises.push(new Promise((resolve, reject) => { this.fc_fetch({ endpoint: 'TextosApp/', method: 'GET', success: (response) => { this.fc_responseList(response, this.$store.state.dictionary); resolve(); }, error: reject }); }));
    Promise.all(promises).then(() => { this.mt_start(); }).catch((e) => { this.fc_printErrors(e); });
  },
  unmounted() {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style>
@import '@/common/css/layout.css';
@import '@/common/css/vars.css';
</style>

<style scoped>
  .cookies-banner {
    position: fixed;
    bottom: 0;
    width: 100%;
    background-color: #000;
    color: white;
    padding: 10px;
    text-align: center;
    z-index: 999;
  }
  .cookies-banner .cookies-banner-text {
    display: inline-block;
    margin-bottom: 10px;
  }
  .cookies-banner button {
    background-color: var(--ibase-color);
    color: white;
    border: none;
    padding: 10px 15px;
    margin-left: 15px;
    cursor: pointer;
    font-size: 14px;
    border-radius: 5px;
  }
  .cookies-banner button:hover {
    background-color: rgb(207, 61, 81);
  }
</style>
